import { render, staticRenderFns } from "./chooseProductAndSpec.vue?vue&type=template&id=364dda58&scoped=true"
import script from "./chooseProductAndSpec.vue?vue&type=script&lang=js"
export * from "./chooseProductAndSpec.vue?vue&type=script&lang=js"
import style0 from "./chooseProductAndSpec.vue?vue&type=style&index=0&id=364dda58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364dda58",
  null
  
)

export default component.exports